import { useMemo } from 'react';

import { VisitMedicalService } from '@dreryk/egabinet-financial-settlement-frontend-api';

import {
   AlignItems,
   createDynamicColumnsWidth,
   HorizontalAlign,
   JustifyContent,
   StaticDataConfiguration,
   TableColumnConfiguration,
   Text,
   TextSeparator,
   TextSeparatorType,
   ValueRendererProps,
} from '@dreryk/react-components';

import { PriceText } from '../../../../shared/price/PriceText';
import { visitSettlementTranslationKeys } from '../../../../translations';

import { StyledPriceText, StyledTooltipText } from './MedicalServicesTable.styled';

export const useMedicalServicesDataConfiguration = (
   medicalServices: VisitMedicalService[] | undefined
): StaticDataConfiguration<VisitMedicalService> => {
   return useMemo(() => {
      return {
         data: medicalServices ?? [],
      };
   }, [medicalServices]);
};

export const useMedicalServicesColumnsConfiguration = (): TableColumnConfiguration<VisitMedicalService>[] => {
   return useMemo<TableColumnConfiguration<VisitMedicalService>[]>(() => {
      const columnsWidth = createDynamicColumnsWidth({
         name: '100%',
         price: '82px',
      });

      return [
         {
            name: 'name',
            label: visitSettlementTranslationKeys.extensions.visitHistory.medicalServicesTab.medicalServiceName,
            width: columnsWidth.name,
            sortingDisabled: true,
            justifyContent: JustifyContent.START,
            alignItems: AlignItems.CENTER,
            accessor: (medicalService) => medicalService,

            renderer: ({ value }: ValueRendererProps<VisitMedicalService, VisitMedicalService>) => (
               <StyledTooltipText testId={'medicalService'}>
                  <TextSeparator separator={TextSeparatorType.SPACE}>
                     <Text testId={'name'}>{value.medicalService.name}</Text>
                     <PriceText
                        testId={'defaultPrice'}
                        value={value.medicalService.priceListPrice.asNumber()}
                        stripDecimalZeroes
                     />
                  </TextSeparator>
               </StyledTooltipText>
            ),
         },
         {
            name: 'price',
            label: visitSettlementTranslationKeys.extensions.visitHistory.medicalServicesTab.medicalServicePrice,
            width: columnsWidth.price,
            sortingDisabled: true,
            textAlign: HorizontalAlign.RIGHT,
            justifyContent: JustifyContent.END,
            alignItems: AlignItems.CENTER,
            accessor: (medicalService) => medicalService,

            renderer: ({ value }: ValueRendererProps<VisitMedicalService, VisitMedicalService>) => (
               <StyledPriceText testId={'customPrice'} value={value.price.asNumber()} stripDecimalZeroes />
            ),
         },
      ];
   }, []);
};
